import PropTypes from 'prop-types';
import { useState, forwardRef } from 'react';
import { Button, Popover } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { always } from 'ramda';

const anchorOrigin = { horizontal: 'right', vertical: 'center' };
const transformOrigin = { vertical: 'center', horizontal: 'left' };

const useStyles = makeStyles(() => ({ root: {} }));

const ButtonPopover = forwardRef(
  (
    {
      anchorOrigin,
      children,
      classes: classesProp,
      onClick,
      onClose,
      title,
      transformOrigin,
      ...props
    },
    ref
  ) => {
    const [anchorEl, setAnchorEl] = useState(null);
    const [open, setOpen] = useState(false);
    const classes = useStyles();

    const handleClick = (event) => {
      event.stopPropagation();
      setAnchorEl(event.currentTarget);
      setOpen(true);
      if (typeof onClick === 'function') {
        onClick(event);
      }
    };
    const handleClose = (event) => {
      event.stopPropagation();
      setAnchorEl(null);
      setOpen(false);
      if (typeof onClose === 'function') {
        onClose(event);
      }
    };

    return (
      <>
        <Button
          {...props}
          ref={ref}
          className={classes.root}
          data-testid="button"
          onClick={handleClick}
        >
          {title}
        </Button>
        {children && (
          <Popover
            anchorEl={anchorEl}
            anchorOrigin={anchorOrigin}
            classes={classesProp}
            onClose={handleClose}
            open={open}
            transformOrigin={transformOrigin}
          >
            <div className={classes.popoverContent}>{children}</div>
          </Popover>
        )}
      </>
    );
  }
);

ButtonPopover.displayName = 'ButtonPopover';

ButtonPopover.propTypes = {
  anchorOrigin: PropTypes.object,
  children: PropTypes.node,
  classes: PropTypes.object,
  onClick: PropTypes.func,
  onClose: PropTypes.func,
  title: PropTypes.string,
  transformOrigin: PropTypes.object,
};

ButtonPopover.defaultProps = {
  anchorOrigin,
  children: null,
  classes: undefined,
  onClick: always,
  onClose: always,
  title: '',
  transformOrigin,
};

export default ButtonPopover;
